<template>
  <v-app id="app_add_category_list">
    <v-container fluid>
      <v-row class="pl-2 pr-6">
        <v-col class="mt-3" cols="7">
          <p class="custom_page_main_title">CATEGORY LIST</p>
          <p class="custom_page_main_sub_title" style="opacity: 0.6">Analyse product categories in your outlet.</p>
        </v-col>
        <v-col class="px-4 mt-5" cols="5">
          <v-row class="custom_tool_bar_style">
            <v-btn color="#800080" size="x-large" variant="text" @click="addProductsPageRoute()">
              <v-icon>mdi-plus-circle</v-icon>&nbsp;&nbsp;ADD CATEGORY
            </v-btn>
            <v-divider :thickness="3" class="divider-vertical" vertical></v-divider>
            <v-btn class="gray-text" size="x-large" variant="text" @click="backPageRoute()">
              <v-icon size="x-large">mdi-menu-left</v-icon>&nbsp;BACK
            </v-btn>
          </v-row>
        </v-col>
      </v-row>

      <v-card class="custom_card_box mt-8 custom-square-card" elevation="1" border="sm opacity-1">
        <v-card-text class="custom_tool_bar_style">
          <v-btn class="custom_pdf_btn custom-square-card" variant="outlined" @click="exportPDF">
            <v-icon size="large">mdi-file-pdf</v-icon>&nbsp;&nbsp;PDF
          </v-btn>
          <v-btn class="custom_excel_btn ml-4 custom-square-card" variant="outlined" @click="exportExcel">
            <v-icon size="large">mdi-file-excel</v-icon>&nbsp;&nbsp;Excel
          </v-btn>
        </v-card-text>

        <v-divider thickness="2"></v-divider>

        <v-card-text>
          <v-row>
            <v-col cols="12" md="4">
              <v-autocomplete
                  v-model="selectedMainCategory" :items="mainCategories" clearable
                  item-title="name" item-value="id" label="Main Category"
                  placeholder="Select main category" variant="outlined"
                  class="custom_input_field_color square-border-input" density="comfortable"
                  chips closable-chips
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-autocomplete
                  v-model="selectedSubCategory" :items="uniqueTableSubCategories"
                  clearable item-title="sub_category_name" item-value="sub_category_name"
                  label="Sub Category" multiple placeholder="Select sub category"
                  variant="outlined" class="custom_input_field_color square-border-input" density="comfortable"
                  chips closable-chips
              ></v-autocomplete>
            </v-col>

            <v-col cols="12" md="4">
              <v-text-field v-model="search" append-inner-icon="mdi-magnify" clearable hide-details
                  label="Search" placeholder="Search Products" variant="outlined" class="custom_input_field_color square-border-input" density="comfortable"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider></v-divider>

          <v-data-table
              v-model:page="page" :headers="headers" :loading="loading"
              :items="filteredItems" :items-per-page="itemsPerPage"
              @page="fetchProducts" class="custom_table_normal"
              @page-count="totalPages = $event"
          >

            <template v-slot:[`item.image_path`]="{ item }">
              <div class="product-column">
                <v-row>
                  <v-col cols="5">
                    <img
                      v-if="(item.image_path && item.image_path.trim() !== '') || (item.image_url && item.image_url.trim() !== '')"
                      :src="formatImageUrl(item.image_url || item.image_path)"
                      class="product_image mt-2 mb-1 custom-square-card"
                      @click="selectImage(formatImageUrl(item.image_url || item.image_path))"
                      style="width: 100%; height: 80px; object-fit: cover; cursor: pointer;"
                    />
                    <div v-else class="product_image mt-2 mb-1 custom-square-card d-flex align-center justify-center" style="background: #f5f5f5; min-height: 80px;">
                      <v-icon color="grey-lighten-1">mdi-image-off</v-icon>
                    </div>
                  </v-col>
                  <v-col class="d-flex align-center" cols="7">
                    <span class="product-title">{{ item.main_category }}</span>
                  </v-col>
                </v-row>
              </div>
            </template>

            <template v-slot:[`item.productsubcatogary`]="{ item }">
              <span v-if="item.productsubcatogary && item.productsubcatogary.length">
                {{ item.productsubcatogary.map(sub => sub.sub_category_name).join(', ') }}
              </span>
            </template>

            <template v-slot:[`item.category_desc`]="{ item }">
              <div v-if="item.category_desc && item.category_desc.length" v-html="getSanitizedHTML(item.category_desc)" class="description-column-wrap">
              </div>
            </template>

            <template v-slot:[`item.action`]="{ item }" >
              <v-menu transition="slide-x-transition" id="app_product_list">
                <template v-slot:activator="{ props }">
                  <v-btn style="background-color: #800080; color: white;" variant="flat" size="large" class="custom-square-card" v-bind="props">
                    ACTIONS &nbsp; &nbsp;<v-icon>mdi-menu-down</v-icon>
                  </v-btn>
                </template>
                  <v-list class="custom-square-card">
                    <v-list-item v-if="permissions.read" @click="viewItem(item)">
                      <v-list-item-title class="custom_font_color_view">VIEW</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="permissions.write" @click="editItem(item)">
                      <v-list-item-title class="custom_font_color_edit">EDIT</v-list-item-title>
                    </v-list-item>

                    <v-list-item v-if="permissions.delete" @click="confirmDelete(item)">
                      <v-list-item-title class="custom_font_color_delete">DELETE</v-list-item-title>
                    </v-list-item>
                  </v-list>
              </v-menu>
            </template>
          </v-data-table>
        </v-card-text>
      </v-card>

      <v-dialog v-model="view_product_dialog" fullscreen id="app_add_category_list">
        <v-card flat class="custom-square-card">
          <v-toolbar style="border-radius: 0px !important;" class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')" @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
              <v-btn 
                variant="flat" 
                class="custom-square-card"
                style="background-color: #800080 !important; color: #ffffff !important;" 
                @click="view_product_dialog = false"
              >
                CLOSE
              </v-btn>
          </v-toolbar>

          <v-row class="mt-15 custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box custom-square-card" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon >mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">PRODUCT CATEGORY DETAILS</v-card-title>
                </template>
              </v-card>

              <v-card class="pa-3 mx-6 custom_card_box mt-4 custom-square-card" border="sm opacity-1">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="9" md="9" lg="9">
                    <v-row>
                      <v-col cols="2">
                        <v-img 
                          v-if="selectedImage" 
                          :src="selectedImage" 
                          aspect-ratio="1" 
                          class="product_image_view custom-square-card"
                          style="min-height: 120px;"
                        ></v-img>
                        <div v-else class="product_image_view custom-square-card d-flex align-center justify-center" style="background: #f5f5f5; min-height: 120px;">
                          <v-icon color="grey-lighten-1" size="48">mdi-image-off</v-icon>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                      <v-btn
                          v-if="permissions.write" class="mr-3 custom_edit_btn custom-square-card"
                          icon size="small"
                          variant="outlined"  @click="editItem(product)"
                      >
                        <v-icon>mdi-pencil</v-icon>
                        <v-tooltip activator="parent" location="top">Edit</v-tooltip>
                      </v-btn>

                      <v-btn
                          v-if="permissions.delete" class="custom_delete_btn custom-square-card"  icon
                          size="small" variant="outlined" @click="confirmDelete(product)"
                      >
                        <v-icon>mdi-trash-can</v-icon>
                        <v-tooltip activator="parent" location="top">Delete</v-tooltip>
                      </v-btn>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-text-field
                        v-model="product.main_category" class="px-3 custom_input_field_class_view custom_input_field_color square-border-input" label="Main Category" readonly
                        variant="outlined" density="comfortable"
                    ></v-text-field>

                    <div v-for="(subCategory, index) in product.productsubcatogary" :key="subCategory.id" class="mb-2">
                      <v-text-field
                          v-model="subCategory.sub_category_name" :label="'Sub Category ' + (index + 1)"  readonly
                          variant="outlined" density="comfortable"  class="px-3 custom_input_field_class_view custom_input_field_color square-border-input"
                      ></v-text-field>
                    </div>

                    <div class="px-3 mb-4">
                      <p class="custom_page_main_sub_title">Category Description</p>
                      <v-divider class="mt-3 mb-4"></v-divider>
                      <v-card color="#F7F7F7" flat border="sm opacity-1" outlined density="comfortable" class="custom-square-card">
                        <v-card-text>
                          <div  v-html="getSanitizedHTML(product.category_desc)" class=" ml-3 ql-container ql-snow"></div>
                        </v-card-text>
                      </v-card>
                    </div>

                  </v-col>

                </v-row>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

      <v-dialog v-model="edit_product_dialog"  fullscreen id="app_add_category_list">
        <v-card class="custom-square-card">
          <v-toolbar style="border-radius: 0px !important;" class="custom_fullscreen_dialog_toolbar pr-5 custom_card_box" color="white" dense>
            <v-toolbar-title>
              <v-img  class="custom_company_logo_nav" :src="require('@/img/company_logo/logo-dark 2.png')" @click="homeReload()"></v-img>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn 
              variant="flat" 
              class="custom-square-card"
              style="background-color: #800080 !important; color: #ffffff !important;" 
              @click="edit_product_dialog = false"
            >
              CLOSE
            </v-btn>
          </v-toolbar>

          <v-row  class="mt-15  custom_scroll_option_fullscreen_dialog">
            <v-col cols="12" md="12">
              <v-card class="pa-0 mx-6 mt-2 custom_card_box custom-square-card" border="sm opacity-1">
                <template v-slot:prepend>
                  <v-icon >mdi-view-dashboard</v-icon>
                  <v-card-title class="font-weight-bold custom_page_main_sub_title ml-3">UPDATE PRODUCT CATEGORY</v-card-title>
                </template>
              </v-card>

              <v-card class="pa-3 mx-6 custom_card_box mt-4 custom-square-card" border="sm opacity-1">
                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="9" md="9" lg="9">
                    <v-row>
                      <v-col cols="2">
                        <v-img 
                          v-if="selectedImage" 
                          :src="selectedImage" 
                          aspect-ratio="1" 
                          class="product_image_view custom-square-card"
                          style="min-height: 120px;"
                        ></v-img>
                        <div v-else class="product_image_view custom-square-card d-flex align-center justify-center" style="background: #f5f5f5; min-height: 120px;">
                          <v-icon color="grey-lighten-1" size="48">mdi-image-off</v-icon>
                        </div>
                      </v-col>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                    <v-row class="text-right mt-3 mr-3">
                      <v-spacer></v-spacer>
                        <v-btn 
                          variant="flat" 
                          size="large" 
                          class="custom-square-card"
                          style="background-color: #800080 !important; color: #ffffff !important;" 
                          @click="updateProduct"
                        >
                          UPDATE PRODUCT CATEGORY
                        </v-btn>
                    </v-row>
                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                    <v-divider></v-divider>
                  </v-col>
                </v-row>

                <v-row class="ma-0">
                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-text-field
                        v-model="product.main_category" :rules="[v => !!v || 'Main category is required', v => /^[a-zA-Z0-9 ]+$/.test(v) || 'Only letters, numbers, and spaces are allowed']" class="custom_input_field_color square-border-input"  label="Main Category *" required variant="outlined" @update:modelValue="fetchSubCategories()"
                         density="comfortable"
                    ></v-text-field>

                    <v-card flat class="custom-square-card">
                      <p class="custom_page_main_sub_title mb-4" style="opacity: 0.6">Update / Change main category image</p>
                      
                      <div class="image-upload-zone custom-square-card" :class="{ 'has-images': previewImage }" @click="triggerFileInput" @drop.prevent="onDrop" @dragover.prevent="onDragOver">
                        <input ref="fileInput" accept="image/*" class="hidden-file-input" type="file" @change="onFileChange"/>
                        
                        <div v-if="!previewImage" class="text-center pa-10">
                          <v-icon size="48" color="grey-lighten-1">mdi-image-plus</v-icon>
                          <p class="mt-2 text-grey">Drag your photo here OR <span style="color:#800080;" class="font-weight-bold">Browse from device</span></p>
                        </div>
                        
                        <div v-else class="position-relative pa-4 w-100 d-flex justify-center">
                          <v-img :alt="'Image preview'" :src="previewImage" aspect-ratio="1" cover class="border custom-square-card" max-height="250" max-width="250">
                            <div class="delete-overlay custom-square-card">
                              <v-btn icon="mdi-delete" color="red" size="large" @click.stop="removeImage"></v-btn>
                            </div>
                          </v-img>
                        </div>
                      </div>

                      <v-row class="mb-8">
                        <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                          <v-btn class="custom_hedging_btn_primary mt-6 custom-square-card" variant="outlined" @click="addSubCategory">
                            <v-icon>mdi-plus-thick</v-icon>&nbsp; Add sub categories</v-btn>
                          <v-divider class="mt-3"></v-divider>
                        </v-col>
                      </v-row>

                      <div v-for="(subCategories, index) in subCategory" :key="subCategories.id">
                        <v-row  style="margin-top: -2% !important;">
                          <v-col cols="12" xs="12" sm="9" md="9" lg="9">
                            <v-text-field
                                v-model="subCategories.sub_category_name"
                                :label="'Sub Category ' + (index + 1)"
                                 density="comfortable"
                                placeholder="Create sub category"
                                variant="outlined" class="custom_input_field_color square-border-input"
                                :rules="[ v => /^[a-zA-Z0-9 ]+$/.test(v) || 'Only letters, numbers, and spaces are allowed']"
                            ></v-text-field>
                          </v-col>

                          <v-col cols="12" xs="12" sm="3" md="3" lg="3">
                            <v-btn v-if="subCategory.length > 0" style="width: 100% !important;" size="x-large" class="custom_btn_secondary_remove custom-square-card"
                                   variant="outlined" @click="removeSubCategory(index)"
                            ><v-icon>mdi-minus-thick</v-icon>&nbsp; Remove</v-btn>
                          </v-col>
                        </v-row>
                      </div>
                    </v-card>

                  </v-col>

                  <v-col cols="12" xs="12" sm="12" md="6" lg="6">
                    <v-row>
                      <v-col cols="12" xs="12" sm="12" md="12" lg="12">
                        <p class="custom_page_main_sub_title" style="opacity: 0.6">Type Description </p>
                        <v-card  class="mt-5 custom-square-card" elevation="1" border="sm opacity-1" max-height="280" min-height="280">
                          <Toolbar :editor="editorRef" :defaultConfig="toolbarConfig" :mode="mode"/>
                          <v-divider></v-divider>
                          <Editor v-model="product.category_desc" :defaultConfig="editorConfig" :mode="mode" @onCreated="handleCreated"/>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-col>
                </v-row>
              </v-card>

            </v-col>
          </v-row>
        </v-card>
      </v-dialog>
      <v-dialog v-model="delete_product_Catagary_dialog" id="app_add_category_list" max-height="500" max-width="500" persistent>
        <v-card id="app_product_list" class="custom-square-card">
          <div class="pa-4">
            <v-card color="#F0F0F0" flat class="custom-square-card">
              <template v-slot:prepend>
                <v-card-title class="text-subtitle-1 font-weight-bold">DELETE PRODUCT CATAGORY</v-card-title>
              </template>
              <v-spacer></v-spacer>
              <template v-slot:append>
                <v-btn @click="delete_product_Catagary_dialog = false" icon="mdi-close" size="x-small"></v-btn>
              </template>
            </v-card>

            <v-card color="white" flat class="mt-3 custom-square-card">
              <v-card-item>
                <v-card-title style="color: #BB0000" class="text-body-1 font-weight-medium">
                  <v-icon color="warning" size="small">mdi-alert</v-icon>
                  &nbsp;&nbsp;Do you want to delete this Catagary ?
                </v-card-title>

                <p style="opacity: 0.7;" class="text-body-2 mt-4 text-justify">
                  This product Catagary will be deleted immediately. Once deleted, it can no longer be used in any purpose.
                </p>

                <v-divider class="mt-4"></v-divider>

                <div class="float-end mt-4 ">
                  <v-btn
                    style="background-color: red; color: white;"
                    class="custom-square-card"
                    @click="deleteItem"
                  >
                    DELETE
                  </v-btn>
                  <v-btn  class="ml-3 custom_btn_secondary custom-square-card" @click="delete_product_Catagary_dialog = false">CANCEL</v-btn>
                </div>
              </v-card-item>
            </v-card>
          </div>
        </v-card>
      </v-dialog>
      <v-snackbar  v-model="snackAlert.snackbar" :color="snackAlert.snackColor" :right="snackAlert.snackBarRight" :top="snackAlert.snackBarTop" location="top right" timeout="3000">
        {{ snackAlert.snackMessage }}
      </v-snackbar>
    </v-container>
  </v-app>
</template>

<script>
import axios from 'axios';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import * as XLSX from "xlsx";
import {getPermissions} from "@/plugins/permissions";
import DOMPurify from 'dompurify';

import '@wangeditor/editor/dist/css/style.css';
import { i18nChangeLanguage } from '@wangeditor/editor'
i18nChangeLanguage('en')
import { Editor, Toolbar } from '@wangeditor/editor-for-vue'
import { onBeforeUnmount, ref, shallowRef, onMounted } from 'vue'

export default {
  components: {
    Editor,
    Toolbar,
  },

  setup() {
    const editorRef = shallowRef()
    const valueHtml = ref('<p></p>')

    onMounted(() => {
      setTimeout(() => {
        valueHtml.value = '<p></p>'
      }, 1500)
    })

    const toolbarConfig = {toolbarKeys: ['bold', 'italic', 'underline', 'through']}
    const editorConfig = { placeholder: 'Type here...' }

    onBeforeUnmount(() => {
      const editor = editorRef.value
      if (editor == null) return
      editor.destroy()
    })

    const handleCreated = (editor) => {
      editorRef.value = editor
    }

    return {
      editorRef,
      mode: 'simple',
      valueHtml,
      toolbarConfig,
      editorConfig,
      handleCreated
    };
  },

  name: 'CategoryLit',
  data() {
    return {
      imageURL:"",
        dataDescription:'',
        formatting: [],
        showColorPicker: false,
        selectedColor: '#000',
        alignment: '',
        textareaStyles: {
          fontStyle: 'normal',
          fontWeight: 'normal',
          textDecoration: 'none',
          color: '#000',
          textAlign: 'left',
        },

      productLoading:false,
      subCategory:[],

      form: {
        images:'',
      },

      search: '',
      selectedMainCategory: null,
      selectedSubCategory: [],

      itemsPerPage: 10,
      page: 1,
      totalPages: 0,

      headers: [
        { text: 'MAIN CATEGORY IMAGE', value: 'image_path', title: 'MAIN CATEGORY IMAGE', sortable: true },
        { text: 'MAIN CATEGORY', value: 'main_category', title: 'MAIN CATEGORY', sortable: true },
        { text: 'SUB CATEGORY', value: 'productsubcatogary', title: 'SUB CATEGORY', sortable: true },
        { text: 'DESCRIPTION', value: 'category_desc', title: 'DESCRIPTION', sortable: true },
        { text: 'ACTION', value: 'action', sortable: false, title: 'ACTION' },
      ],

      delete_product_Catagary_dialog: false,
      view_product_dialog: false,
      edit_product_dialog: false,
      selectedProductId: null,
      product: {},

      numericRule: value => !isNaN(parseFloat(value)) || 'Price must be a number',

      item:[],
      mainCategories: [],
      subCategories: [],
      loading:false,
      items: [],

      product_image: [],
      previewImage: null,
      selectedImage: '',
      permissions: { read: false, write: false, delete: false },

      snackAlert: {
        snackbar: false,
        snackColor: "",
        snackMessage: "",
        snackBarRight: false,
        snackBarTop: true,
      },
      productcheck: null,
      dialog: false,
      modes: ['hsla', 'rgba', 'hexa'],
    };
  },
  created() {
    this.imageURL = process.env.VUE_APP_API_BASE_URL;
    this.fetchProducts();
    this.fetchMainCategories();
  },
  methods: {

    formatImageUrl(path) {
      if (!path) return '';
      let cleanPath = path.trim();
      
      if (cleanPath.startsWith('[') && cleanPath.endsWith(']')) {
        try {
          const parsed = JSON.parse(cleanPath);
          if (parsed && parsed.length > 0 && parsed[0].image) {
            cleanPath = parsed[0].image.trim();
          }
        } catch(e) {
          console.warn('Image parsing error - not a valid JSON array:', e.message);
        }
      }
      
      if (cleanPath.startsWith('http://') || cleanPath.startsWith('https://') || cleanPath.startsWith('data:image')) {
        return cleanPath;
      }
      
      let base = process.env.VUE_APP_API_BASE_URL ? process.env.VUE_APP_API_BASE_URL.replace(/\/+$/, '') : '';
      
      cleanPath = cleanPath.replace(/^\/+/, '');
      
      const prefixesToRemove = [
        'piyestra/storage/app/public/', 
        'storage/app/public/', 
        'SFA/storage/app/public/', 
        'storage/', 
        'public/'
      ];
      
      let modified = true;
      while (modified) {
        modified = false;
        for (let prefix of prefixesToRemove) {
          if (cleanPath.startsWith(prefix)) {
            cleanPath = cleanPath.substring(prefix.length).replace(/^\/+/, '');
            modified = true;
          }
        }
      }
      
      if (!cleanPath.startsWith('/')) {
        cleanPath = '/' + cleanPath;
      }
      
      return base + '/piyestra/storage/app/public' + cleanPath;
    },

    getSanitizedHTML(html) {
    return DOMPurify.sanitize(html);
    },
    convertToPlainText(html) {
      const sanitizedHTML = this.getSanitizedHTML(html);
      const tempDiv = document.createElement('div');
      tempDiv.innerHTML = sanitizedHTML;
      return tempDiv.textContent || tempDiv.innerText || '';
    },
    applyFormat(format) {

      if (format === 'italic') {
        this.textareaStyles.fontStyle =
            this.textareaStyles.fontStyle === 'italic' ? 'normal' : 'italic';
      } else if (format === 'bold') {
            this.textareaStyles.fontWeight =
            this.textareaStyles.fontWeight === 'bold' ? 'normal' : 'bold';
      } else if (format === 'underline') {
            this.textareaStyles.textDecoration =
            this.textareaStyles.textDecoration === 'underline'
                ? 'none'
                : 'underline';
      } else if (format === 'color') {
          this.textareaStyles.color = this.selectedColor;
        }
      },

    setAlignment(align) {
      this.textareaStyles.textAlign = align;
    },

    addSubCategory() {
      this.subCategory.push({id: Date.now(), subcatagaryName: ''});
    },
    removeSubCategory(index) {
      this.subCategory.splice(index, 1);
    },

    sizeValidation(value) {
      const sizePattern = /^\d+(\.\d+)?\s*(cm|centimeter|centimeters|mm|millimeter|millimeters|in|inches|m|meter|meters|ft|feet|other)$/i;
      return sizePattern.test(value.trim());
    },
    exportExcel() {

      function stripHTMLTags(input) {
          if (!input) return "";
          const doc = new DOMParser().parseFromString(input, 'text/html');
          let text = doc.body.textContent || "";
          return text.replace(/\s+/g, ' ').trim();
        }

      const tableData = this.filteredItems.map((item, index) => ({
        'NO': index + 1,
        'PRODUCT MAIN CATEGORY NAME': item.main_category || '',
        'SUBCATEGORY': item.productsubcatogary && item.productsubcatogary.length > 0
          ? item.productsubcatogary.map(sub => sub.sub_category_name).join(', ')
          : '',
        'DESCRIPTION':  stripHTMLTags(item.category_desc) || '',
      }));

      const worksheet = XLSX.utils.json_to_sheet(tableData);
      
      const wscols = [
        { wch: 8 },  
        { wch: 35 }, 
        { wch: 50 }, 
        { wch: 70 }  
      ];
      worksheet['!cols'] = wscols;

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Products Category');
      XLSX.writeFile(workbook, 'products_category.xlsx');

      const fileName = 'products_category.xlsx';
      const file_type = 'excel';
      this.logDocumentDownload(fileName,file_type);
    },


    exportPDF() {
      const doc = new jsPDF();
      doc.text('Product Catagory Details', 14, 10);

      function stripHTMLTags(input) {
          if (!input) return "";
          const parsedDoc = new DOMParser().parseFromString(input, 'text/html');
          let text = parsedDoc.body.textContent || "";
          return text.replace(/\s+/g, ' ').trim();
        }

      const tableData = this.filteredItems.map((item, index) => [
        index + 1,
        item.main_category,
        item.productsubcatogary && item.productsubcatogary.length > 0 
          ? item.productsubcatogary.map(sub => sub.sub_category_name).join(', ') 
          : '',
        stripHTMLTags(item.category_desc),
      ]);

      const tableColumns = ['NO', 'MAIN CATEGORY','SUBCATEGORY','DESCRIPTION'];

      doc.autoTable({
        head: [tableColumns],
        body: tableData,
        theme: 'grid',
        styles: {
          overflow: 'linebreak',
          valign: 'top',
          fontSize: 9,
          font: 'helvetica',
          cellPadding: 3,
        },
        headStyles: {
          fillColor: [25, 118, 210],
          textColor: 255,
          fontStyle: 'bold',
          font: 'helvetica',
          fontSize: 9,
        },
        columnStyles: {
          0: { cellWidth: 10 },
          1: { cellWidth: 30 },
          2: { cellWidth: 45 },
          3: { cellWidth: 95 },
        },
      });
      doc.setFontSize(10);
      doc.text(`Generated on: ${new Date().toLocaleDateString()}`, 14, doc.internal.pageSize.height - 10);

      doc.save('products_category.pdf');
      const fileName = 'products_category.pdf';
      const file_type = 'pdf';
      this.logDocumentDownload(fileName,file_type);
    },

    async logDocumentDownload(fileName,file_type) {
      console.log(fileName);
      try {
        const token = localStorage.getItem('token');
        const userId = localStorage.getItem('userId');

        if (!userId) {
          throw new Error('User ID not found');
        }

        const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/log-document-download`, {
          user_id: userId,
          file_type: file_type,
          file_name: fileName,
          entity_area: 'Product Management',

          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'application/json'
          }
        });

        if (response.status !== 200) {
          throw new Error('Failed to log download');
        }

        console.log('Download logged successfully');
      } catch (error) {
        console.error('Error logging download:', error);
      }
    },

    showSnackbar(message, color) {
      this.snackAlert.snackbar = true;
      this.snackAlert.snackMessage = message;
      this.snackAlert.snackColor = color;
    },

    fetchMainCategories() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/mainProduct`, {
        userId: userId
      }, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        let sample = response.data.data;
        this.mainCategories = sample.map(item => {
          return {
            id: item.id,
            name: item.main_category
          };
        });
        console.log('Main categories:', this.mainCategories);
      })
      .catch(error => {
        console.error('Error fetching main categories:', error);
      });
    },

    fetchSubCategories() {
      const token = localStorage.getItem('token');
      const userId = localStorage.getItem('userId');
      this.productLoading = true;
      this.selectedSubCategory = null;
      this.product.sub_category = null;
      let mainCatagoryId = this.selectedMainCategory || this.product.main_category
      console.log('Main Category ID:', this.product.main_category);
      console.log('Main Category ID t:', this.selectedMainCategory);

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/subcatagoryProduct`,
          {
            userId: userId,
            mainCatagoryId: mainCatagoryId
          },
          {
            headers: {
              'Authorization': `Bearer ${token}`,
              'Content-Type': 'application/json'
            }
          })

      .then(response => {
        console.log('API Response:', response);
        this.subCategories = response.data.data;
        console.log('Subcategories:', this.subCategories);
        const selectedCategory = this.mainCategories.find(cat => cat.id === mainCatagoryId);
        this.product.main_category_name = selectedCategory ? selectedCategory.name : '';
        this.productLoading = false;
        console.log('Selected Main Category Name:', this.product.main_category_name);
      })
      .catch(error => {
        console.error('Error fetching sub categories:', error);
        this.productLoading = false;
      });
    },

    getCategoryName(categoryId) {
      console.log('Looking up categoryId:', categoryId);
      if (typeof categoryId === 'string') {
        categoryId = parseInt(categoryId, 10);
      }
      const category = this.mainCategories.find(cat => cat.id === categoryId);
      console.log('Found category:', category);
      return category ? category.name : 'Unknown';
    },

    validateForm() {
        if (!this.product.main_category) {
          this.showSnackbar('Main category is required.', 'error');
          return false;
        }

        const mainCategoryRegex = /^[a-zA-Z0-9 ]+$/;
        if (!mainCategoryRegex.test(this.product.main_category)) {
          this.showSnackbar('Main category must contain only letters, numbers, and spaces.', 'error');
          return false;
        }

        if (!this.subCategory.length) {
          this.showSnackbar('Al least One Sub category is required.', 'error');
          return false;
        }
        
        if (!this.product.category_desc) {
          this.showSnackbar('Category description is required.', 'error');
          return false;
        }
        return true;
      },

    async updateProduct() {

      if (!this.validateForm()) {
          return;
      }

      const formData = new FormData();
      formData.append('mainCatagaryId', this.product.id);
      formData.append('mainCatagaryName', this.product.main_category);
      formData.append('mainCatagaryDescription', this.product.category_desc);
      formData.append('userId', localStorage.getItem('userId'));

      const transformedSubCategory = this.subCategory.map(sub => ({
        ...sub,
        subcatagaryName: sub.sub_category_name,
        sub_category_name: undefined
      }));

      const subCatagoryJson = JSON.stringify(transformedSubCategory);
      formData.append('subCatagaryDetails', subCatagoryJson);
      console.log('Transformed subCategory:', subCatagoryJson);

      try {
        console.log('jjjjjjj', this.form.images)
        if (this.form.images && (this.form.images.size > 0 || this.form.images.name)) {
          console.log('ssssss')
          const base64Images = await this.convertToBase64(this.form.images);
          formData.append('mainCatagaryImage', base64Images);

          console.log('fuk img',base64Images);
        }

        for (let [key, value] of formData.entries()) {
          console.log(`${key}:`, value);
        }

        const token = localStorage.getItem('token');
        const response = await axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/updateCatagaryDetails`, formData, {
          headers: {
            'Authorization': `Bearer ${token}`,
            'Content-Type': 'multipart/form-data'
          }
        });

        if (response.data.success) {
          this.snackAlert.snackbar = true;
          this.snackAlert.snackColor = 'success';
          this.snackAlert.snackMessage = 'Product updated successfully';
          this.view_product_dialog = false;
          this.edit_product_dialog = false;
          this.fetchProducts();
          this.product.main_category_name = '';
          this.selectedMainCategory = '';
        } else {
          this.snackAlert.snackbar = true;
          this.snackAlert.snackColor = 'error';
          this.snackAlert.snackMessage = 'Failed to update product';
          this.fetchProducts();
        }
      } catch (error) {
        this.snackAlert.snackbar = true;
        this.snackAlert.snackColor = 'error';
        this.snackAlert.snackMessage = 'Please fill out all required fields correctly';
        console.error('Error updating product:', error);
      }
    },


    convertToBase64(file) {
      console.log('ffffffffffffff',file);
      return new Promise((resolve, reject) => {
        if (file instanceof Blob) {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
        } else {
          reject(new Error('Invalid file type'));
        }
      });
    },

    homeReload() {
      window.location.href = '/dashboard';
    },

    fetchProducts() {
      this.loading = true;
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem("token");
      const formData = new FormData();
      formData.append("userId", userId);

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/getCatagaryDetails`, formData, {
        headers: {
          'Authorization': `Bearer ${token}`
        }
      })
      .then(response => {
        this.items = response.data.data.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));
        this.loading = false;
        console.log('Result', response.data.data);
      })
      .catch(error => {
        console.error('Error fetching categories:', error);
        this.loading = false;
      });
    },

    addProductsPageRoute() {
      this.$router.push({path: '/products-category'});
    },

    viewItem(item) {
      this.selectedProductId = item.id;
      this.product = {...item};
      
      this.selectedImage = (item.image_url || item.image_path) ? this.formatImageUrl(item.image_url || item.image_path) : '';
      
      this.previewImages = item.product_image || [];
      this.view_product_dialog = true;
      this.subCategory = item.productsubcatogary || [];
      console.log("View item:", item);
      console.log("View sub:", this.subCategory);
      console.log("Selected image URL:", this.selectedImage);
    },

    editItem(item) {
      this.edit_product_dialog = true;
      this.selectedProductId = item.id;
      this.product = {...item};
      
      this.selectedImage = (item.image_url || item.image_path) ? this.formatImageUrl(item.image_url || item.image_path) : '';
      this.previewImage = (item.image_url || item.image_path) ? this.formatImageUrl(item.image_url || item.image_path) : null;
      
      this.subCategory = item.productsubcatogary || [];
      this.form.images = '';
      console.log('Editing item:', item);
      console.log("Edit selected image URL:", this.selectedImage);
    },

    confirmDelete(item) {
      this.delete_product_Catagary_dialog = true;
      this.selectedProductId = item.id;
      console.log('Deleting item:', this.selectedProductId);
    },

    deleteItem() {
      const userId = localStorage.getItem('userId');
      const token = localStorage.getItem('token');
      const ProductID = this.selectedProductId;
      console.log('delete id', ProductID);

      axios.post(`${process.env.VUE_APP_API_BASE_URL}/api/deleteCatagaryDetails`, {
        userId: userId,
        mainCatagaryId: ProductID,
      }, {
        headers: {
          'Authorization': `Bearer ${token}`,
          'Content-Type': 'application/json'
        }
      })

      .then(() => {
        this.fetchProducts();
        this.delete_product_Catagary_dialog = false;
        this.view_product_dialog = false;
        this.showSnackbar("Product Category was successfully deleted.", "success");
      })
      .catch((error) => {
        console.log('Error deleting Product', error);
        this.delete_product_Catagary_dialog = false;
        this.fetchProducts();
      });
    },

    backPageRoute() {
      this.$router.back();
    },

    selectImage(image) {
      this.selectedImage = image;
    },

    triggerFileInput() {
      this.$refs.fileInput.click();
    },

    onFileChange(event) {
      const file = event.target.files[0];
      if (file) {
        this.previewImage = URL.createObjectURL(file);
        this.handleFiles(file);
      }
    },

    onDrop(event) {
      const file = event.dataTransfer.files[0];
      if (file) {
        this.previewImage = URL.createObjectURL(file);
        this.handleFiles(file);
      }
    },

    onDragOver(event) {
      event.preventDefault();
    },

    removeImage() {
      this.previewImage = null;
      this.form.images = '';
      if (this.$refs.fileInput) {
        this.$refs.fileInput.value = null;
      }
    },

    handleFiles(file) {
      const validImageTypes = ['image/jpeg', 'image/png', 'image/gif', 'image/webp'];

      if (!validImageTypes.includes(file.type)) {
        alert('Only image files are allowed!');
        return;
      }

      if (!(file instanceof File)) {
        console.error('Not a valid File object:', file);
        return;
      }

      this.form.images = file;
    },
  },

  mounted() {
    this.permissions = getPermissions(0, "Module Name");

    if (!this.permissions.read) {
      this.showSnackbar ? this.showSnackbar("Access Denied", "error") : alert("Access Denied");
      this.$router.push('/dashboard');
    }
    console.log("Permissions:", this.permissions);
  },

  computed: {
    uniqueTableSubCategories() {
      const subCatsMap = new Map();
      let sourceItems = this.items;

      if (this.selectedMainCategory) {
        const selectedCatObj = this.mainCategories.find(c => c.id === this.selectedMainCategory || c.name === this.selectedMainCategory);
        const selectedCatName = selectedCatObj ? selectedCatObj.name : this.selectedMainCategory;
        sourceItems = sourceItems.filter(item => item.main_category === selectedCatName);
      }

      sourceItems.forEach(item => {
        if (item.productsubcatogary && Array.isArray(item.productsubcatogary)) {
          item.productsubcatogary.forEach(sub => {
            if (sub.sub_category_name && !subCatsMap.has(sub.sub_category_name)) {
              subCatsMap.set(sub.sub_category_name, { sub_category_name: sub.sub_category_name });
            }
          });
        }
      });

      return Array.from(subCatsMap.values());
    },

    oldPrice() {
      const price = parseFloat(this.product.price);
      const discountRate = parseFloat(this.product.discount_rate);
      if (discountRate > 0) {
        return (price / (1 - discountRate / 100)).toFixed(2);
      }
      return price.toFixed(2);
    },
    
    filteredItems() {
      return this.items.filter(product => {
        let selectedCatName = null;
        if (this.selectedMainCategory) {
          const selectedCatObj = this.mainCategories.find(c => c.id === this.selectedMainCategory || c.name === this.selectedMainCategory);
          selectedCatName = selectedCatObj ? selectedCatObj.name : this.selectedMainCategory;
        }

        const matchesMainCategory = !selectedCatName || product.main_category === selectedCatName;

        const matchesSubCategory = !this.selectedSubCategory ||
          this.selectedSubCategory.length === 0 ||
          (product.productsubcatogary && product.productsubcatogary.some(sub =>
            this.selectedSubCategory.includes(sub.sub_category_name)
          ));

        const matchesSearch = !this.search ||
        (product.main_category && product.main_category.toLowerCase().includes(this.search.toLowerCase())) ||
        (product.productsubcatogary && product.productsubcatogary.some(sub =>
          sub.sub_category_name && sub.sub_category_name.toLowerCase().includes(this.search.toLowerCase())
        ));

        return matchesMainCategory && matchesSubCategory && matchesSearch;
      });
    }
  },
};
</script>

<style lang="scss" scoped>
  @use "../../styles/product_management/category_list.scss" as *;

  .custom_font_color_view {
  color: #1976D2 !important;
  font-weight: 500;
}

.custom_font_color_edit {
  color: #388E3C !important;
  font-weight: 500;
}

.custom_font_color_delete {
  color: #D32F2F !important;
  font-weight: 500;
}

.image-upload-zone {
  border: 2px dashed #e0e0e0;
  border-radius: 2px;
  min-height: 180px;
  transition: all 0.3s ease;
  cursor: pointer;
  background: #fcfcfc;
  display: flex;
  align-items: center;
  justify-content: center;
}

.image-upload-zone:hover {
  border-color: #800080;
  background: #faf5fa;
}

.image-upload-zone.has-images {
  display: flex;
  min-height: auto;
}

.delete-overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.3);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: 0.2s;
}

.position-relative:hover .delete-overlay {
  opacity: 1;
}

.custom-square-card {
  border-radius: 2px !important;
}

.square-border-input :deep(.v-field),
.square-border-input :deep(.v-field__outline),
.square-border-input :deep(.v-field__overlay),
.square-border-input :deep(.v-field__outline__start),
.square-border-input :deep(.v-field__outline__end),
.square-border-input :deep(.v-field__outline__notch::before),
.square-border-input :deep(.v-field__outline__notch::after) {
  border-radius: 2px !important;
}

.description-column-wrap {
  white-space: normal !important;
  word-break: break-word !important;
  min-width: 220px;
  max-width: 380px;
  display: block;
}
</style>